//* App Custom
import { EMAIL_PATTERN, INPUT_REQUIRED } from '@constantsApp/inputRules';
import { verifyData } from '@utilsApp/index';

export const updateContactInformationInputs = ({ contactInfo }) => {
  const { emails = [] } = contactInfo;

  const safeEmails = emails.length > 0 ? emails : [{ email: '' }];

  return safeEmails.map((email, index) => ({
    type: 'text',
    name: `emails.${index}.email`,
    label: `Correo ${index + 1}`,
    placeholder: 'placeholders.email',
    defaultValue: email.email,
    rules: { ...INPUT_REQUIRED, ...EMAIL_PATTERN },
    design: safeEmails.length === 1 ? 'col-12' : 'col-6'
  }));
};

export const patientInfoObtained = ({ contactInfo }) => {
  const { patient = [] } = contactInfo;

  return [
    {
      label: 'labels.names',
      value: verifyData([patient?.first_name, patient?.second_name])
    },
    {
      label: 'labels.last_names',
      value: verifyData([patient?.first_last_name, patient?.second_last_name])
    },
    {
      label: 'labels.document',
      value: verifyData([
        patient?.document_set?.[0]?.document_type?.code,
        patient?.document_set?.[0]?.number
      ])
    }
  ];
};
